import React, {
  useState,
  useCallback,
  useEffect
} from 'react';
import { useLocation } from "react-router-dom";
import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles'
import Page from 'src/components/Page';
import Header from './Header';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import CustomerPrivacyPolicyEditForm from './CustomerPrivacyPolicyEditForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100
  }
}));

function CustomerPrivacyPolicyEdit({ match, location }) {
  const {state} = useLocation();
  const classes = useStyles();
  const isMountedRef = useIsMountedRef();
  const [service, setService] = useState();

  const getService = useCallback(() => {
      setService(state)
  }, [isMountedRef]);

  useEffect(() => {
    getService();
  }, [getService]);

  if (!service) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="Edit Privacy Policy"
    >
      <Container maxWidth="lg">
        <Header />
        <br/>
        <CustomerPrivacyPolicyEditForm service={service}/>
      </Container>
    </Page>
  );
}

export default CustomerPrivacyPolicyEdit;
